import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/hooks/use-toast";
import { api } from "@/api";
import { formatError } from "@/components/shared/helpers";
import { useTranslation } from "@/components/shared/i18n";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email });
      toast({ title: t("forgot.success"), description: t("forgot.success_desc") });
    } catch (err) {
      toast({ title: t("forgot.error"), description: formatError(err), variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060A14] text-slate-50 relative">
      <div className="absolute inset-x-0 top-0 h-[380px] bg-[radial-gradient(ellipse_at_top,rgba(56,189,248,0.28),transparent_60%),radial-gradient(ellipse_at_top_left,rgba(125,211,252,0.18),transparent_55%),radial-gradient(ellipse_at_bottom_right,rgba(59,130,246,0.12),transparent_55%)]" aria-hidden />
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-12">
        <Card data-testid="forgot-password-card" className="w-full max-w-sm border-white/10 bg-[#0b0d12]/80 backdrop-blur">
          <CardHeader>
            <CardTitle data-testid="forgot-password-title" className="text-center text-slate-50">{t("forgot.title")}</CardTitle>
            <div data-testid="forgot-password-subtitle" className="text-sm text-slate-300 text-center">{t("forgot.subtitle")}</div>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1">
                <Label data-testid="forgot-email-label">{t("forgot.email")}</Label>
                <Input data-testid="forgot-email-input" type="email" className="border-white/10 bg-white/[0.08]" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <Button data-testid="forgot-submit-button" type="submit" className="w-full rounded-full bg-violet-500 text-white hover:bg-violet-400" disabled={loading}>
                {loading ? t("forgot.loading") : t("forgot.submit")}
              </Button>
              <div className="text-center">
                <a data-testid="forgot-back-link" href="/login" className="text-sm text-violet-400 hover:underline" onClick={(e) => { e.preventDefault(); navigate("/login"); }}>
                  {t("forgot.back")}
                </a>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
